module.exports = __webpack_public_path__ + "static/futurama-1fcea016af432389e7b444ae3b95abf2.gif";